import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DwComponent, DwComponentSectionPreference, DwComponentType, DwExpressionService, DwFormActionKeys, DwFormContextMode, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwQueryHelper, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, getParameterByName } from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { RequestEntity } from 'src/app/meta-data/app-meta-data.service';
import { EquipRentalMetaDataItemNames, EquipRentalMetaDataService } from '../../meta-data/equiprental-meta-data.service';

@DwComponent(
  {
    key: 'copy-equip-request',
    name: 'Copy Equipment Request',
    componentType: DwComponentType.formSection,
    isGlobal: false,
    parentItemName: EquipRentalMetaDataItemNames.Request,
  }
)
@Component({
  selector: 'app-copy-equip-request',
  template: ''
})
export class CopyEquipRequestComponent extends DwSectionBaseComponent<DwComponentSectionPreference>
  implements OnInit {

  equipRental: RequestEntity;

  constructor(@Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private router: Router,
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
  }

  setupComponentComplete() {
    if (!this.formGroup || !this.formConfig) {
      return;
    }

    if (this.formConfig.formMode == DwFormContextMode.add) {
      this.getEquipTemplateId();
    }
  }

  getEquipTemplateId() {
    const copyRequestId = getParameterByName(this.router, 'copyRequestId');

    // Ignore if we're not copying a request
    if (!copyRequestId) {
      return;
    }

    this.loadEquipment(copyRequestId).subscribe(result => {
      const copiedEquipRequest = result;
      this.setEquipmentRequest(copiedEquipRequest);
    });
  }

  loadEquipment(requestId: number): Observable<RequestEntity> {
    const md = new EquipRentalMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.Request.CreateQuery();

    query.AddFilterAnd(qh.filters.Equal(md.Request.RequestId, requestId));

    query.AddPrefetchPath(md.Request.Relations.RequestEquipment);

    query.FieldSettings.LoadAllLookupDisplayFields = true;

    return this.dwOrmDataService.executeQuerySingle(query);
  }

  setEquipmentRequest(equipRequest: RequestEntity) {
    // Note: Using a null RequestEquipementId causes issues on edit since it needs to be unique.  Using -100 since the in memory data source strts at -1 and we don't want them to conflict
    let nextKey = -100;

    equipRequest.RequestEquipment.forEach(x => {

      x.RequestId = null;
      x.RequestEquipmentId = nextKey;

      nextKey--;
    });

    equipRequest.RequestId = null;
    equipRequest.NeededByDateTime = null;
    equipRequest.DeliveredByDateTime = null;
    equipRequest.JobName = null;
    equipRequest.JobNumber = null;
    equipRequest.JobSiteAddress = null;
    equipRequest.SiteContactName = null;
    equipRequest.SiteContactPhoneNumber = null;
    equipRequest.DropOffArea = null;
    equipRequest.Notes = null;

    this.formGroup.patchValue(equipRequest);
  }
}
